import { ToastContainer as Toast } from "react-toastify";

import { TOAST_CLOSE_TIME } from "constants/index";

import "react-toastify/dist/ReactToastify.css";
import styles from "./ToastContainer.module.css";

const ToastContainer = () => {
  return (
    <div className={styles.container}>
      <Toast
        position="top-right"
        autoClose={TOAST_CLOSE_TIME}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default ToastContainer;
